import React, { useState, useEffect } from 'react';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import MultiFileUploadS3 from '../../../../core/components/core/Util/Form/CustomInputs/MultiFileUploadS3';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

import { EDUCATION_LEVEL_OPTIONS } from '../candidatePortal/constants/options';
const academicOptions = EDUCATION_LEVEL_OPTIONS;

let isSubmitAttempted = false;

function VacanciesSection({ values, handleChange, errors, inputRefs, form }) {
    const [roles, setRoles] = useState([]);
    const [submittedIds, setSubmittedIds] = useState([]);
    const readOnly = !!form?.readOnly;
    const vacancies = Array.isArray(values?.vacancies) ? values.vacancies : [];

    useEffect(() => {
        let isMounted = true;
        const loadRoles = async () => {
            try {
                const response = await Fetch.post(`${config.endpoints.backend}psp/roles/getall`, {});
                if (isMounted && Array.isArray(response)) {
                    setRoles(response);
                }
            } catch (err) {
                console.error('Erro ao buscar roles:', err);
            }
        };
        loadRoles();
        return () => { isMounted = false; };
    }, []);

    useEffect(() => {
        const markSubmitted = () => {
            isSubmitAttempted = true;
            setSubmittedIds(vacancies.map((v, i) => v.id || `idx_${i}`));
        };

        const handleCaptureClick = (e) => {
            const btn = e.target && e.target.closest && e.target.closest('button');
            if (btn) {
                const isFooter = Boolean(btn.closest('.card-footer') || btn.closest('.modal-footer'));
                const isPrimary = btn.classList.contains('btn-primary') && !btn.classList.contains('btn-outline-primary');
                if (isFooter && isPrimary) {
                    markSubmitted();
                }
            }
        };

        const handleKeyDown = (e) => {
            if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') {
                markSubmitted();
            }
        };

        const handleSubmitCapture = (e) => {
            if (e.target && e.target.id === 'crudform') {
                markSubmitted();
            }
        };

        document.addEventListener('click', handleCaptureClick, true);
        document.addEventListener('keydown', handleKeyDown, true);
        document.addEventListener('submit', handleSubmitCapture, true);

        return () => {
            document.removeEventListener('click', handleCaptureClick, true);
            document.removeEventListener('keydown', handleKeyDown, true);
            document.removeEventListener('submit', handleSubmitCapture, true);
        };
    }, [vacancies]);

    const updateVacancies = (newList) => {
        handleChange({
            target: {
                name: 'vacancies',
                value: newList
            }
        });
    };

    const handleAddVacancy = () => {
        isSubmitAttempted = false;
        const newVacancy = {
            id: `temp_${Date.now()}_${vacancies.length}`,
            psp_role_id: '',
            title: '',
            description: '',
            responsibilities_and_duties: '',
            requirements_and_qualifications: '',
            academic_background: '',
            behavioral_skills: '',
            requirements_desirable: '',
            has_exam: false,
            exam_date: '',
            exam_type: '',
            exam_local: '',
            exam_instructions: '',
            files: []
        };
        updateVacancies([...vacancies, newVacancy]);
    };

    const handleRemoveVacancy = (index) => {
        const removed = vacancies[index];
        const updated = vacancies.filter((_, i) => i !== index);
        if (removed) {
            const removedId = removed.id || `idx_${index}`;
            setSubmittedIds((prev) => prev.filter((id) => id !== removedId));
        }
        if (updated.length === 0) {
            isSubmitAttempted = false;
        }
        updateVacancies(updated);
    };

    const handleFieldChange = (index, field, value) => {
        const updated = vacancies.map((v, i) => {
            if (i === index) {
                return { ...v, [field]: value };
            }
            return v;
        });
        updateVacancies(updated);
    };

    return (
        <div
            className="w-100"
            ref={(el) => {
                if (inputRefs && inputRefs.current) {
                    inputRefs.current['vacancies'] = el;
                }
            }}
        >
            {vacancies.length === 0 && (
                <div className="alert alert-light border text-center p-4 mb-3">
                    <p className="text-muted mb-2">Nenhuma vaga cadastrada neste edital ainda.</p>
                    {!readOnly && (
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={handleAddVacancy}
                        >
                            <i className="fas fa-plus mr-1"></i> Inserir Primeira Vaga
                        </button>
                    )}
                </div>
            )}

            {vacancies.map((vacancy, index) => {
                const vacId = vacancy.id || `idx_${index}`;
                const isSubmitted = submittedIds.includes(vacId);
                const roleError = Boolean(isSubmitted && (!vacancy.psp_role_id || !String(vacancy.psp_role_id).trim()));
                const titleError = Boolean(isSubmitted && (!vacancy.title || !String(vacancy.title).trim()));
                const descError = Boolean(isSubmitted && (!vacancy.description || !String(vacancy.description).trim()));
                const examTypeError = Boolean(isSubmitted && vacancy.has_exam && (!vacancy.exam_type || !String(vacancy.exam_type).trim()));

                return (
                    <div key={vacancy.id || index} className="card card-outline card-primary mb-4 shadow-sm">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="card-title font-weight-bold text-primary">
                                <i className="fas fa-id-card-alt mr-2"></i>
                                Vaga {index + 1}: {vacancy.title || 'Sem título'}
                            </h3>
                            {!readOnly && (
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm ml-auto"
                                    onClick={() => handleRemoveVacancy(index)}
                                    title="Remover Vaga"
                                >
                                    <i className="fas fa-trash mr-1"></i> Remover Vaga
                                </button>
                            )}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="font-weight-bold">
                                        Função / Cargo (PSP) <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className={`form-control ${roleError ? 'is-invalid' : ''}`}
                                        value={vacancy.psp_role_id || ''}
                                        onChange={(e) => handleFieldChange(index, 'psp_role_id', e.target.value)}
                                        disabled={readOnly}
                                    >
                                        <option value="">Selecione uma função...</option>
                                        {roles.map((r) => (
                                            <option key={r.id} value={r.id}>
                                                {r.name} {r.area_role_name ? `(${r.area_role_name})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                    {roleError && <div className="invalid-feedback d-block">A função / cargo é obrigatória.</div>}
                                </div>

                                <div className="col-md-6 form-group">
                                    <label className="font-weight-bold">
                                        Título da Vaga <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${titleError ? 'is-invalid' : ''}`}
                                        placeholder="Ex: Enfermeira Pediátrica"
                                        value={vacancy.title || ''}
                                        onChange={(e) => handleFieldChange(index, 'title', e.target.value)}
                                        disabled={readOnly}
                                    />
                                    {titleError && <div className="invalid-feedback d-block">O título da vaga é obrigatório.</div>}
                                </div>

                                <div className="col-12 form-group">
                                    <label className="font-weight-bold">
                                        Descrição Geral da Vaga <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        className={`form-control ${descError ? 'is-invalid' : ''}`}
                                        rows="3"
                                        placeholder="Descreva o propósito da vaga..."
                                        value={vacancy.description || ''}
                                        onChange={(e) => handleFieldChange(index, 'description', e.target.value)}
                                        disabled={readOnly}
                                    />
                                    {descError && <div className="invalid-feedback d-block">A descrição geral da vaga é obrigatória.</div>}
                                </div>

                                <div className="col-md-6 form-group">
                                    <label className="font-weight-bold">Responsabilidades e Atribuições</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder="Principais tarefas e responsabilidades..."
                                        value={vacancy.responsibilities_and_duties || ''}
                                        onChange={(e) => handleFieldChange(index, 'responsibilities_and_duties', e.target.value)}
                                        disabled={readOnly}
                                    />
                                </div>

                                <div className="col-md-6 form-group">
                                    <label className="font-weight-bold">Requisitos e Qualificações (Obrigatórios)</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder="Experiência, certificações, registros profissionais..."
                                        value={vacancy.requirements_and_qualifications || ''}
                                        onChange={(e) => handleFieldChange(index, 'requirements_and_qualifications', e.target.value)}
                                        disabled={readOnly}
                                    />
                                </div>

                                <div className="col-md-4 form-group">
                                    <label className="font-weight-bold">Formação Acadêmica Exigida</label>
                                    <select
                                        className="form-control"
                                        value={vacancy.academic_background || ''}
                                        onChange={(e) => handleFieldChange(index, 'academic_background', e.target.value)}
                                        disabled={readOnly}
                                    >
                                        <option value="">Selecione o nível de escolaridade...</option>
                                        {academicOptions.map((opt) => (
                                            <option key={opt} value={opt}>
                                                {opt}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-4 form-group">
                                    <label className="font-weight-bold">Competências Comportamentais</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder="Ex: Comunicação, proatividade, liderança..."
                                        value={vacancy.behavioral_skills || ''}
                                        onChange={(e) => handleFieldChange(index, 'behavioral_skills', e.target.value)}
                                        disabled={readOnly}
                                    />
                                </div>

                                <div className="col-md-4 form-group">
                                    <label className="font-weight-bold">Requisitos Desejáveis (Opcional)</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder="Diferenciais para a vaga..."
                                        value={vacancy.requirements_desirable || ''}
                                        onChange={(e) => handleFieldChange(index, 'requirements_desirable', e.target.value)}
                                        disabled={readOnly}
                                    />
                                </div>

                                <div className="col-12 mt-2">
                                    <div className="p-3 bg-light rounded border">
                                        <div className="custom-control custom-checkbox mb-2">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id={`has_exam_${vacancy.id || index}`}
                                                checked={!!vacancy.has_exam}
                                                onChange={(e) => handleFieldChange(index, 'has_exam', e.target.checked)}
                                                disabled={readOnly}
                                            />
                                            <label
                                                className="custom-control-label font-weight-bold"
                                                htmlFor={`has_exam_${vacancy.id || index}`}
                                            >
                                                Esta vaga terá etapa de Prova (Técnica ou Prática)?
                                            </label>
                                        </div>

                                        {vacancy.has_exam && (
                                            <div className="row pt-2 mt-2 border-top">
                                                <div className="col-md-4 form-group">
                                                    <label className="font-weight-bold small text-uppercase">
                                                        Data Estimada da Prova
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={vacancy.exam_date ? vacancy.exam_date.slice(0, 10) : ''}
                                                        onChange={(e) => handleFieldChange(index, 'exam_date', e.target.value)}
                                                        disabled={readOnly}
                                                    />
                                                </div>

                                                <div className="col-md-4 form-group">
                                                    <label className="font-weight-bold small text-uppercase">
                                                        Formato da Prova <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        className={`form-control ${examTypeError ? 'is-invalid' : ''}`}
                                                        value={vacancy.exam_type || ''}
                                                        onChange={(e) => handleFieldChange(index, 'exam_type', e.target.value)}
                                                        disabled={readOnly}
                                                    >
                                                        <option value="">Selecione o formato...</option>
                                                        <option value="Prova Teórica (Objetiva)">Prova Teórica (Objetiva)</option>
                                                        <option value="Prova Prática / Dinâmica">Prova Prática / Dinâmica</option>
                                                    </select>
                                                    {examTypeError && <div className="invalid-feedback d-block">O formato da prova é obrigatório.</div>}
                                                </div>

                                                <div className="col-md-4 form-group">
                                                    <label className="font-weight-bold small text-uppercase">
                                                        Local da Prova
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Endereço ou plataforma online"
                                                        value={vacancy.exam_local || ''}
                                                        onChange={(e) => handleFieldChange(index, 'exam_local', e.target.value)}
                                                        disabled={readOnly}
                                                    />
                                                </div>

                                                <div className="col-12 form-group">
                                                    <label className="font-weight-bold small text-uppercase">
                                                        Instruções da Prova
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        placeholder="Orientações aos candidatos sobre o exame..."
                                                        value={vacancy.exam_instructions || ''}
                                                        onChange={(e) => handleFieldChange(index, 'exam_instructions', e.target.value)}
                                                        disabled={readOnly}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 form-group mt-3 border-top pt-3">
                                    <label className="font-weight-bold">
                                        <i className="fas fa-paperclip mr-1 text-primary"></i> Anexos da Vaga
                                    </label>
                                    <p className="text-muted small mb-2">
                                        Anexe documentos específicos desta vaga (editais complementares, fichas de perfil, referências técnicas).
                                    </p>
                                    <MultiFileUploadS3
                                        name={`vacancy_files_${vacancy.id || index}`}
                                        path="psp/vacancies"
                                        file={Array.isArray(vacancy.files) ? vacancy.files : []}
                                        limitFileSize={100}
                                        uploadFileLimit={10}
                                        titleButton="Anexar Arquivos da Vaga"
                                        disabled={readOnly}
                                        onUpload={(_, uploadedFiles) => {
                                            handleFieldChange(index, 'files', uploadedFiles);
                                        }}
                                        onRemove={(_, fileToRemove) => {
                                            const currentFiles = Array.isArray(vacancy.files) ? vacancy.files : [];
                                            const remaining = currentFiles.filter((f) => f.files3 !== fileToRemove?.files3);
                                            handleFieldChange(index, 'files', remaining);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

            {!readOnly && vacancies.length > 0 && (
                <button
                    type="button"
                    className="btn btn-outline-primary btn-block py-3 font-weight-bold mb-4"
                    onClick={handleAddVacancy}
                    style={{ borderStyle: 'dashed', borderWidth: '2px' }}
                >
                    <i className="fas fa-plus mr-2"></i> Inserir mais uma Vaga neste Edital
                </button>
            )}
        </div>
    );
}

function Form() {
    const pathFrontEnd = '/psp-selectionprocesses/';
    const pathBackEnd = config.endpoints.backend + 'psp/selectionprocesses/';

    const profileFilter = chooseProfileFilter()

    useEffect(() => {
        isSubmitAttempted = false;
        return () => {
            isSubmitAttempted = false;
        };
    }, []);

    const form = {
        labelTitleEdit: 'Editar Processo Seletivo',
        labelTitleView: 'Visualizar Processo Seletivo',
        labelTitleAdd: 'Novo Processo Seletivo',
        pathView: pathFrontEnd + 'view',
        urlGoBack: pathFrontEnd + 'list',
        endpointGetById: pathBackEnd + 'getById',
        endpointSave: pathBackEnd + 'save',
        validateOnChange: true,
        fields: [
            {
                name: 'label_info_geral',
                type: 'label',
                label: '1. Informações Gerais',
                value: '',
                columnSize: 12
            },
            {
                name: 'pdc_projects',
                label: 'Projetos Vinculados',
                type: 'multiselect',
                columnSize: 12,
                options: [],
                optionsEndpoint: {
                    endpoint: config.endpoints.backend + 'projects/getall',
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: true
                }
            },
            {
                name: 'title',
                label: 'Título do Processo Seletivo',
                type: 'text',
                placeholder: 'Ex: Processo Unificado 2026/01',
                columnSize: 6,
                validations: {
                    required: true
                }
            },
            {
                name: 'edital_number',
                label: 'Número do Edital',
                type: 'text',
                placeholder: 'Ex: ED-001-2026',
                columnSize: 6,
                validations: {
                    required: false
                }
            },
            {
                name: 'units_and_staffing',
                label: 'Unidades / Lotação',
                type: 'text',
                placeholder: 'Ex: Todas as Unidades Básicas de Saúde da Região Leste',
                columnSize: 12,
                validations: {
                    required: false
                }
            },
            {
                name: 'divider_1',
                type: 'divider',
                columnSize: 12
            },
            {
                name: 'label_calendario',
                type: 'label',
                label: '2. Automação e Calendário Base',
                value: '',
                columnSize: 12
            },
            {
                name: 'subscriber_initial_date',
                label: 'Início das Inscrições',
                type: 'datetime',
                columnSize: 4,
                validations: {
                    required: true
                }
            },
            {
                name: 'subscriber_end_date',
                label: 'Fim das Inscrições (Fecha)',
                type: 'datetime',
                columnSize: 4,
                validations: {
                    required: false
                }
            },
            {
                name: 'status',
                label: 'Status Imediato',
                type: 'select',
                columnSize: 4,
                options: [
                    { label: 'Em breve (Aguardando Data)', value: 'em_breve' },
                    { label: 'Período de Inscrição (Aberto Agora)', value: 'inscricao' },
                    { label: 'Inscrições Encerradas', value: 'inscricao_encerrada' },
                    { label: 'Etapa de Provas', value: 'provas' },
                    { label: 'Análise de Resultados', value: 'analise_resultados' },
                    { label: 'Envio de Documentos', value: 'documentos' },
                    { label: 'Resultado Parcial', value: 'resultado_parcial' },
                    { label: 'Resultado Final', value: 'resultado_final' }
                ],
                validations: {
                    required: true
                }
            },
            {
                name: 'divider_2',
                type: 'divider',
                columnSize: 12
            },
            {
                name: 'label_vagas',
                type: 'label',
                label: '3. Vagas e Requisitos do Edital',
                value: '',
                columnSize: 12
            },
            {
                name: 'vacancies',
                label: 'Vagas e Requisitos do Edital',
                type: 'customInput',
                columnSize: 12,
                validations: {
                    validateVacanciesList: true
                },
                component: (props) => <VacanciesSection {...props} />
            }
        ],
        customValidators: {
            validateVacanciesList: (value) => {
                if (!isSubmitAttempted) {
                    return undefined;
                }
                const list = Array.isArray(value) ? value : [];
                for (let i = 0; i < list.length; i++) {
                    const v = list[i];
                    if (!v.psp_role_id || !String(v.psp_role_id).trim()) {
                        return '^Existem campos obrigatórios não preenchidos nas vagas.';
                    }
                    if (!v.title || !String(v.title).trim()) {
                        return '^Existem campos obrigatórios não preenchidos nas vagas.';
                    }
                    if (!v.description || !String(v.description).trim()) {
                        return '^Existem campos obrigatórios não preenchidos nas vagas.';
                    }
                    if (v.has_exam && (!v.exam_type || !String(v.exam_type).trim())) {
                        return '^Existem campos obrigatórios não preenchidos nas vagas.';
                    }
                }
                return undefined;
            }
        }
    };

    return (
        <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
        />
    );
}

export default Form;
